/*
 * @Author: Nora Galvin
 * @Date: 2020-08-17 11:52:25
 * @Last Modified by: Nora
 * @Last Modified time: 2020-09-17 15:13:23
 */

import interactionsTemplate from '@/app/editor/sidebar/interactions/templates/interactions.html';
import dropdownTemplate from '@/app/editor/sidebar/interactions/templates/action-dropdown.html';

import type { TypeInteraction, TypeInteractionExport, TypeAnimationConfigs } from './type';

import { interactions } from './configs/interaction';

import { animations } from './configs/animations';
import type { TypeAnimation } from './animations/type';

import { atomIDToBkID } from '@/app/utils/helpers';

import { atomLevel1, atomLevel2 } from '@/app/editor/sidebar/interactions/configs/atom';

import type Animation from './animations';
import Interaction from './interaction';
import { app } from '@/store';
import { base } from '@/app/editor/sidebar/constant';
/**
 * Interaction class
 */
export default class InteractionPanel {
  protected readonly _interactions: Array<TypeInteraction> = interactions;
  protected readonly _animations: Array<TypeAnimation> = animations;
  protected readonly _atomLevel1 = atomLevel1;
  protected readonly _atomLevel2 = atomLevel2;

  _$atom: JQuery;
  _$gfLeftSideBar: JQuery;
  _$interactionTab: JQuery;
  _$interactionPanel: JQuery;
  _$gfFrame: JQuery;

  // Should have a config/setting/data in each Atom instead of check by label

  _selectedAnimation: Animation;

  /**
   * Constructor
   * @param $atom ..
   */
  constructor($atom: JQuery) {
    this._$atom = $atom;
    this._$gfLeftSideBar = jQuery('#gfLeftSideBar');
    this._$interactionTab = jQuery('.simple-tabs');
    this._$gfFrame = jQuery('#gfFrame');
    this.openSettings();
  }

  /**
   * openSettings
   * @returns void
   */
  openSettings(): void {
    this.renderTemplate();
    this.renderItems();
    return;
  }

  /**
   * renderTemplate
   * @returns void
   */
  renderTemplate(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;
    const $oldPanel = this._$gfLeftSideBar.find('#md-settings .simple-tabs .interactions-panel');
    if ($oldPanel.length) {
      $oldPanel.remove();
    }
    $(interactionsTemplate()).insertAfter(this._$gfLeftSideBar.find('#md-settings .simple-tabs .md-body').last());

    // Need async function to init data
    this._$interactionPanel = this._$interactionTab.find('.interactions-panel');

    (this._$interactionPanel.addClass('optiscroll') as any).optiscroll();

    const $dropdown = this._$interactionTab.find('.tab-action-dropdown');

    const integrations = this.getInteractions(this._$atom.data('label'));
    this._$gfLeftSideBar.find('#md-settings .simple-tabs .tab-action-dropdown').html(dropdownTemplate(integrations));

    // Toggle click to show dropdown
    this._$interactionTab
      .find('.tab-action-icon')
      .off('click')
      .on('click', function () {
        $(this).toggleClass('active');
        $dropdown.slideToggle(200);
      });

    // Click outside
    jQuery(window).click(function (event) {
      if (!$(event.target).parents('.tab-action').is('.tab-action')) {
        $('.tab-action-icon').removeClass('active');
        $dropdown.slideUp(200);
      }
    });

    // Hover to show description
    $dropdown.find('.tab-item').hover(
      function () {
        if ($(this).hasClass('disabled')) {
          return;
        }
        const desc = _this.getInteractionDesc($(this).data('key'), $(this).data('type'));
        $dropdown.find('.tab-item-description p').text(desc);
        $dropdown.find('.tab-item-description').show();
      },
      function () {
        $dropdown.find('.tab-item-description').hide();
      },
    );

    // Click to add item
    $dropdown
      .find('.tab-item')
      .off('click')
      .on('click', function () {
        if ($(this).hasClass('disabled')) {
          return false;
        }

        $dropdown.slideUp(200);
        _this._$interactionTab.find('.tab-action-icon').removeClass('active');

        const interaction = _this.getInteractionByKeyLevel($(this).data('key') || '', $(this).data('type') || '');

        if (interaction) {
          const opts = {
            /**
             * onInteractionDeleted
             * @param interaction ..
             */
            onInteractionDeleted: (interaction: TypeInteraction) => {
              // Remove disabled interaction status
              _this._$interactionTab.find(`.tab-item[data-key=${interaction.key}]`).removeClass('disabled');

              const $interactionItems = _this._$interactionPanel.find('.interactions-list .interaction-item');
              if (!$interactionItems || !$interactionItems.length) {
                _this._$interactionPanel.find('.interactions-empty').show();
              }
            },
          };

          // Expand all other
          const otherItems = _this._$interactionPanel.find('.interactions-list').find('.interaction-item');
          otherItems.removeClass('active');
          otherItems.find('.interaction-content').slideUp(200);

          new Interaction(interaction, _this._$atom, undefined, opts);

          $(this).addClass('disabled');
          // $(this).unbind("click");
          // _this.doAddItem(interaction);
        }
      });

    return;
  }

  /**
   * Load interactions from divContentBk then render list to DOM
   */
  renderItems(): void {
    // Check no animation or no divContentBk, then show empty page
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;
    const atomID = this._$atom.attr('id') || '';
    const contentBkID = atomIDToBkID(atomID);
    let interactionJSON: TypeInteractionExport | undefined = undefined;

    const interaction = (app as any).$store.getters['editor/GET_ANIMATION_INTERACTION_SETTING_BY_KEY'](
      base._interactions + '_' + contentBkID,
    );
    if (interaction) {
      interactionJSON = JSON.parse(interaction);
    }

    if (!interactionJSON || !interactionJSON.animations || !interactionJSON.animations.length) {
      this._$interactionPanel.find('.interactions-empty').show();
      return;
    }

    if (interactionJSON) {
      // Find and replace
      // const interactionJSON: TypeInteractionExport = JSON.parse($interactionDiv.text());
      interactionJSON.animations.forEach((e) => {
        if (e.interaction && e.interaction.key && e.interaction.type) {
          const interaction = this.getInteractionByKeyLevel(e.interaction.key, e.interaction.type);
          if (interaction) {
            const animation = this.contentBkToAnimation(e.animation);
            const opts = {
              /**
               * onInteractionDeleted
               * @param interaction ..
               */
              onInteractionDeleted: (interaction: TypeInteraction) => {
                // Remove disabled interaction status
                _this._$interactionTab.find(`.tab-item[data-key=${interaction.key}]`).removeClass('disabled');

                const $interactionItems = _this._$interactionPanel.find('.interactions-list .interaction-item');
                if (!$interactionItems || !$interactionItems.length) {
                  _this._$interactionPanel.find('.interactions-empty').show();
                }
              },
            };

            new Interaction(interaction, this._$atom, animation, opts);
            // Expand all other
            const otherItems = this._$interactionPanel.find('.interactions-list').find('.interaction-item');
            otherItems.removeClass('active');
            otherItems.find('.interaction-content').hide();

            // Disable button select
            this._$interactionTab
              .find(`.tab-item[data-key=${e.interaction.key}][data-type=${e.interaction.type}]`)
              .addClass('disabled');
          }
        }
      });
    } else {
      this._$interactionPanel.find('.interactions-empty').show();
    }

    return;
  }

  /**
   * Transform data from contentBk to TypeAnimation
   * @param data ..
   * @returns animation
   */
  contentBkToAnimation(data: TypeAnimationConfigs): TypeAnimation | undefined {
    const animKey = data.name?.split('_')[0];
    if (!animKey) return undefined;
    let animation = this.findAnimationByKey(animKey);
    animation = JSON.parse(JSON.stringify(animation));
    if (!animation) return undefined;

    // Update settings
    const suffixMatches = data.name?.match(/_[a-zA-Z-]*/g);
    if (suffixMatches) {
      for (let i = 0; i < suffixMatches.length; i++) {
        let suffix = suffixMatches[i];
        if (suffix.charAt(0) == '_') {
          suffix = suffix.slice(1);
          if (animation.settings) {
            animation.settings[i].value = suffix;
          }
        }
      }
    }

    // Update options
    animation.options?.forEach((e) => {
      switch (e.key) {
        case 'delay':
          e.value = data.delay;
          break;
        case 'duration':
          e.value = data.duration;
          break;
        case 'screens':
          e.options?.forEach((screen) => {
            switch (screen.key) {
              case 'lg':
                screen.value = data.screens.lg;
                break;
              case 'md':
                screen.value = data.screens.md;
                break;
              case 'xs':
                screen.value = data.screens.xs;
                break;
              case 'sm':
                screen.value = data.screens.sm;
                break;
            }
          });
          // e.options = data.screens;
          break;
        case 'loop':
          e.options?.forEach((el) => {
            switch (el.key) {
              case 'iteration':
                el.value = data['iteration-count'];
                break;
            }
          });
          break;
      }
    });
    return animation;
  }

  /**
   * Get interactions of atom
   * @param atomLabel string
   * @returns array of interactions
   */
  getInteractions(atomLabel: string): Array<TypeInteraction> {
    const atomL1 = this._atomLevel1.get(atomLabel);
    if (atomL1) {
      return this._interactions.filter((e) => e.type == 'level1');
    }

    const atomL2 = this._atomLevel2.get(atomLabel);
    if (atomL2) {
      return this._interactions.filter((e) => e.type == 'level2');
    }

    return [];
  }

  /**
   * Get interaction by key
   * @param key string
   * @param level string
   * @returns a object interaction
   */
  getInteractionByKeyLevel(key: string, level: string): TypeInteraction | undefined {
    return this._interactions.find((e) => e.key == key && e.type == level);
  }

  /**
   * Get Description of Integration
   * @param interactionKey string
   * @param level string
   * @returns string
   */
  getInteractionDesc(interactionKey: string, level: string): string {
    const interaction = this._interactions.find((e) => e.key == interactionKey && e.type == level);
    if (interaction) {
      return interaction.description || '';
    }
    return '';
  }

  /**
   * Find animation by key
   * @param key ..
   * @returns animationd
   */
  findAnimationByKey(key: string): TypeAnimation | undefined {
    return this._animations.find((e) => e.key == key);
  }
}
